import React from 'react'

const TickIcon = (props = {}) => {
  const {
    className = '',
    width = '',
    height = '',
    fill = 'none',
    viewBox = '0 0 24 24',
    dataTestId = 'tick-icon',
    ariaLabel = 'Tick Icon',
    fillColor = '#FFFFFF', // Set default fill color to white
  } = props || {}
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      className={className}
      viewBox={viewBox}
      data-testid={dataTestId}
      aria-label={ariaLabel}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.2l-4.2-4.2L3 13.8l6 6 12-12-1.8-1.8L9 16.2z"
        fill={fillColor}
      />
    </svg>
  )
}

export default TickIcon
export { TickIcon }
